import { classify } from 'sidecar-utilities'

export const arrowStyles = 'color-iconInverse-bold-default'

export const tipStyles = ({
  component = 'tooltip',
}: {
  // This style is used by the toggletip too
  component?: 'tooltip' | 'toggletip' | 'onboardingspotlight'
}) => {
  let availableHeight, transformOrigin

  switch (component) {
    case 'tooltip':
      availableHeight = 'var(--radix-tooltip-content-available-height)'
      transformOrigin = 'var(--radix-tooltip-content-transform-origin)'
      break

    case 'toggletip':
    case 'onboardingspotlight':
      availableHeight = 'var(--radix-popover-content-available-height)'
      transformOrigin = 'var(--radix-popover-content-transform-origin)'
      break
  }

  return classify({
    color: 'color-textOnInverse-bold-default color-inverse-bold-default',
    // Make the content a little smaller
    typography:
      component !== 'onboardingspotlight' &&
      'sh-body-sm [&_p]:mb-3 [&_p:last-child]:mb-0',
    // We expect spotlights to have longer copy so they get to be wider
    width: component === 'onboardingspotlight' ? 'max-w-sm' : 'max-w-2xs',
    // Max height is the remaining height between the trigger and the boundary edge
    height: `max-h-[${availableHeight}]`,
    padding: 'p-3',
    //animates up or down depending on how much space is available on the screen
    animation: `data-[side=bottom]:animate-slide-down data-[side=top]:animate-slide-up`,
    animationOrigin: `origin-[${transformOrigin}]`,
    // need to be > 701, otherwise tooltips will appear underneath modals
    other: 'rounded-lg z-800',
  })
}
